import React from 'react'
import { GridLoader } from 'react-spinners'

export default function Loader() {
    return (
        <div className='loader-container'>
            <GridLoader color='#A67F38' />
        </div>
    )
}
